import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { addPunch, closePunchModal } from '../actions/index';
import { Modal } from 'react-bootstrap';

class ModalPunch extends Component {
  constructor(props) {
    super(props);

    this.state = {
      employee_num: '',
      message: '',
    }
  }

  handlePunchChange = num => {
    // If we have a message, lets reset the employee num before continuing
    if (this.state.message) {
      this.setState({ employee_num: '' }, function() {
        let new_employee_num = this.state.employee_num + num;
        this.setState({ employee_num: new_employee_num, message: '' });
      });
    } else {
      let new_employee_num = this.state.employee_num + num;
      this.setState({ employee_num: new_employee_num, message: '' });
    }
  }

  handlePunchReset = () => {
    this.setState({ employee_num: '', message: '' });
  }

  handleClosePunchModal = () => {
    this.props.closePunchModal();
  }

  handleAddPunch = () => {
    this.props.addPunch(this.state.employee_num).then(message => {
      this.setState({ message: message });
    });
  }

  render() {
    return(
      <Modal show={this.props.modals.showPunchModal} onHide={this.handleClosePunchModal}>
        <Modal.Header closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="center-text">
            <div className="pb-1">
              <span className="h3 text-muted">Clock in with your employee number</span>
            </div>
            <div>
              <span className="h1 text-center">&nbsp;{this.state.employee_num}</span>
              <br />
              <span className="h5 text-center mt-1">&nbsp;{this.state.message}</span>
            </div>
            <div className="mt-1">
              <button type="button" onClick={event => this.handlePunchChange(7)} className="btn btn-lg btn-circle btn-black">7</button>
              &nbsp;&nbsp;
              <button type="button" onClick={event => this.handlePunchChange(8)} className="btn btn-lg btn-circle btn-black">8</button>
              &nbsp;&nbsp;
              <button type="button" onClick={event => this.handlePunchChange(9)} className="btn btn-lg btn-circle btn-black">9</button>
              <br /><br />
              <button type="button" onClick={event => this.handlePunchChange(4)} className="btn btn-lg btn-circle btn-black">4</button>
              &nbsp;&nbsp;
              <button type="button" onClick={event => this.handlePunchChange(5)} className="btn btn-lg btn-circle btn-black">5</button>
              &nbsp;&nbsp;
              <button type="button" onClick={event => this.handlePunchChange(6)} className="btn btn-lg btn-circle btn-black">6</button>
              <br /><br />
              <button type="button" onClick={event => this.handlePunchChange(1)} className="btn btn-lg btn-circle btn-black">1</button>
              &nbsp;&nbsp;
              <button type="button" onClick={event => this.handlePunchChange(2)} className="btn btn-lg btn-circle btn-black">2</button>
              &nbsp;&nbsp;
              <button type="button" onClick={event => this.handlePunchChange(3)} className="btn btn-lg btn-circle btn-black">3</button>
              <br /><br />
              <button type="button" onClick={event => this.handlePunchChange(0)} className="btn btn-lg btn-circle btn-black">0</button>
              <br /><br />
              <button type="button" onClick={event => this.handlePunchReset()} className="btn btn-lg btn-rounded btn-danger">Reset</button>
              &nbsp;
              <button type="button" onClick={event => this.handleAddPunch()} className="btn btn-lg btn-rounded btn-success">Submit</button>
            </div>
            <div>

            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
        </Modal.Footer>
      </Modal>
    );
  }
}

function mapStateToProps({ modals }) {
  return { modals };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators( { addPunch, closePunchModal }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalPunch);



// WEBPACK FOOTER //
// ./src/containers/modal_punch.js